var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRefundArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16553 1.13438C5.3155 1.2844 5.39976 1.48784 5.39976 1.69998C5.39976 1.91211 5.3155 2.11555 5.16553 2.26558L3.33113 4.09998H7.79993C9.28514 4.09998 10.7095 4.68997 11.7597 5.74018C12.8099 6.79038 13.3999 8.21476 13.3999 9.69998V11.3C13.3999 11.5121 13.3156 11.7156 13.1656 11.8657C13.0156 12.0157 12.8121 12.1 12.5999 12.1C12.3878 12.1 12.1843 12.0157 12.0342 11.8657C11.8842 11.7156 11.7999 11.5121 11.7999 11.3V9.69998C11.7999 8.63911 11.3785 7.62169 10.6284 6.87155C9.87821 6.1214 8.86079 5.69998 7.79993 5.69998H3.33113L5.16553 7.53438C5.24193 7.60817 5.30288 7.69645 5.34481 7.79405C5.38673 7.89166 5.4088 7.99663 5.40973 8.10286C5.41065 8.20908 5.39041 8.31442 5.35018 8.41274C5.30996 8.51106 5.25056 8.60038 5.17544 8.67549C5.10033 8.75061 5.01101 8.81001 4.91269 8.85023C4.81437 8.89046 4.70903 8.9107 4.60281 8.90978C4.49658 8.90885 4.39161 8.88678 4.294 8.84486C4.1964 8.80293 4.10812 8.74198 4.03433 8.66558L0.834327 5.46558C0.68435 5.31555 0.600098 5.11211 0.600098 4.89998C0.600098 4.68784 0.68435 4.4844 0.834327 4.33438L4.03433 1.13438C4.18435 0.984399 4.3878 0.900146 4.59993 0.900146C4.81206 0.900146 5.0155 0.984399 5.16553 1.13438Z",
    fill: "#979797"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefundArrow);
export default __webpack_public_path__ + "static/media/refund_arrow.4541a4f4f82beefb75c9f68f27acf10a.svg";
export { ForwardRef as ReactComponent };